import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';

import { BorrowerLoansDashboard } from '../modules/borrowerLoans/borrowerLoansDashboard';
import {
  getLoanRoutesConfig,
  getPlatformLoanRoutesConfig,
} from '@roc/feature-loans-routes-config';
import {
  BorrowerExternalCapitalLoanDetailsV3,
  BorrowerInternalCapitalLoanDetailsV3,
} from '../modules/borrowerLoanDetails/borrowerLoanDetailsV3';
import { BorrowerLoanDetailsV2 } from '../modules/borrowerLoanDetails/borrowerLoanDetailsV2';

export const getBorrowerLoanRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return getLoanRoutesConfig(basePath, baseUrl);
};

export const getPlatformBorrowerLoanRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return getPlatformLoanRoutesConfig(basePath, baseUrl);
};

export const getBorrowerLoanRoutes = (basePath: string, baseUrl: string) => {
  const config = getBorrowerLoanRoutesConfig(basePath, baseUrl);
  const platformConfig = getPlatformBorrowerLoanRoutesConfig(basePath, baseUrl);
  return {
    loansDashboard: (
      <Route exact path={config.loansHome.path}>
        <Page routeDefinition={config.loansHome}>
          <BorrowerLoansDashboard />
        </Page>
      </Route>
    ),
    loanDetails: (
      <Route
        path={[config.loans().children.drawDetails().path, config.loans().path]}
      >
        <BorrowerInternalCapitalLoanDetailsV3 />
      </Route>
    ),
    platformLoanDetails: (
      <Route
        path={[
          platformConfig.loans().children.drawDetails().path,
          platformConfig.loans().path,
        ]}
      >
        <BorrowerExternalCapitalLoanDetailsV3 />
      </Route>
    ),
  };
};
